import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Button,
  Modal,
  Form,
  Col,
  Table,
  Spin,
  Select,
  Divider,
  Tag,
} from "antd";

import { CheckCircleOutlined } from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
// import DownloadTableButtons from "../../../components/DownloadTableButtons";
import { rightAction } from "../../../redux/actions";
import { handleFlgStatus } from "../../../components/facilities/AccountFacility";
import { apiConfig, labelConfig, staticConfig } from "../reports.config";
import DownloadTableButtons from "../../../components/layouts/enhancement/DownloadTableButtons";

const { Text, Title } = Typography;

const columns = [
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Type",
    dataIndex: "type",
  },
  {
    title: "Category",
    dataIndex: "category",
  },
];

const ManageTreasuryReports = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("25");
  const [reportsList, setReportsList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  useEffect(() => {
    getReportsList();
  }, []);

  const getReportsList = () => {
    const params = {
      R_reportCategory: "10",
      genericResultSet: false,
      parameterType: true,
    };

    const url = `${apiConfig.RunReports}/reportCategoryList`;

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempCasaReportsList = [];
        // const filteredArray = objList.filter((item) => item.parameter_name === "OfficeIdSelectOne");
        const filteredArray = objList;
        console.log(filteredArray);

        filteredArray.forEach((element) => {
          const exists = tempCasaReportsList.find((item) => item.name === element.report_name);
          console.log(exists);
          if (
            element.report_type?.toLowerCase() !== "sms" &&
            element.report_type?.toLowerCase() !== "pentaho" &&
            // element.report_category?.toLowerCase() === "savings" &&
            !exists
          ) {
            tempCasaReportsList.push({
              key: element?.parameter_id ?? element?.report_id,
              id: element?.parameter_id ?? element?.report_id,
              name: element?.report_name ? element?.report_name : "-",
              type: element?.report_type ? element?.report_type : "-",
              category: element?.report_category ? element?.report_category : "-",
            });
          }
        });

        setReportsList(tempCasaReportsList);
        setOriginalList(tempCasaReportsList);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    console.log(selectedRowKeys, objParam);
    dispatch({ type: cnt.CLEAR_RIGHT_BTN });
    //HOLD THE OBJECT SELECTED HERE
    if (selectedRowKeys.length === 1) {
      setSelectedRow(objParam[0]);
      [cnt.RIGHT_RUN_BTN].map((item) => {
        dispatch({ type: item });
      });
    }
  };
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setReportsList(originalList);
      return;
    }
    const filterBySearch = originalList.filter((item) =>
      item?.name?.toLowerCase().includes(searchKey?.toLowerCase())
    );
    setReportsList(filterBySearch);
  }
  function selectTableCount(value) {
    setTableCount(value);
  }
  console.log(selectedRow);
  function handleOnRun() {
    const { runBtn } = rightBtn;
    if (runBtn.toLowerCase() === "primary") {
      navigate("/run-treasury-reports", { state: { id: selectedRow.id, name: selectedRow.name } });
    } else {
      console.log("Could not open the link");
    }
  }
  console.log(reportsList);
  return (
    <MainLayout
      isEnableRightSidebar={true}
      onRun={handleOnRun}
      pageItems={staticConfig.manageTreasuryReportsBreadcrumbItems}
    >
      <TopContent
        pageTitle={labelConfig.treasuryReports}
        createPageTitle={`${labelConfig.reports} Listing`}
      />

      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginTop: 12,
        }}
      >
        {/* RENDER TABLE LIST HERE*/}
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name"
                style={{
                  width: 400,
                }}
                allowClear
              />
            </div>

            <DownloadTableButtons
              downloadData={reportsList}
              columns={columns}
              fileName={labelConfig.treasuryReports}
            />
          </Row>
          <Table
            rowSelection={{
              type: "checkbox",
              onChange: onSelectItemAction,
              hideSelectAll: true,
            }}
            columns={columns}
            dataSource={reportsList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
              showSizeChanger: false,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(ManageTreasuryReports);
